import client from '../client.js';
import createQuery from './create.graphql';

export const createCheckout = async function (input) {
    let result = await client.request(createQuery, input);

    return {
        url: result.checkoutCreate.checkout.webUrl,
    };
};
